import styles from './About.module.css';
import { useTranslation } from 'react-i18next';

export const About = () => {
  const { t } = useTranslation();
  const skills = ['React',   'JavaScript','TypeScript','CSS3', 'HTML5', 'Git','GitHub', 'PHP'];

  
  return (
    <div className={styles.about}>
      <h1>
        {t('about.title')}
      </h1>

      <div className={styles.section}>
        <p className={styles.content}>
          {t('about.content')}
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles['section-title']}>
          {t('about.education')}
        </h2>
        <p className={styles.content}>
          {t('about.educationContent')}
        </p>
      </div>

      <div className={styles.section}>
        <h2 className={styles['section-title']}>
          {t('about.skills')}
        </h2>
        <div className={styles.skills}>
          {skills.map((skill) => (
            <div key={skill} className={styles['skill-tag']}>
              {skill}
            </div>
          ))}
        </div>
      </div>

      <div className={styles.section}>
        <h2 className={styles['section-title']}>
          {t('about.moreTitle')}
        </h2>
        <p className={styles.content}>
          {t('about.moreContent')}
        </p>
      </div>
      <div className={styles.section}>
        <h2 className={styles['section-title']}>
          {t('about.CVtitle')}
        </h2>
        <p className={styles.content}>
          {t('about.CVen')}: <a href='/CVen.pdf' download={"CV_Wislocki.pdf"} className={styles.download}>
          {t("about.CVdownload")}
        </a>
        </p>
        <p className={styles.content}>
          {t('about.CVcz')}: <a href="/zivotopiscj.pdf" download={"Životopis_Wislocki.pdf"} >
          {t("about.CVdownload")}
        </a>
        </p>
        
      </div>

    </div>
  );
};
